export { default } from './LoanTags';
